module.exports = __webpack_public_path__ + "static/media/HCMM967.d0d6749e.jpg";